const PREFIX = '@EPG_WIDGET';

export const SHOW = `${PREFIX}/SHOW`;
export const HIDE = `${PREFIX}/HIDE`;
